export default __webpack_public_path__ + "static/studio-1-3187eb3ce8e6e97798225fb9a3bc03bd.jpg";